import React, { useState } from "react";
import { Mail, Lock, Loader2, AlertCircle, Eye, EyeOff } from 'lucide-react';

function LoginForm({ onSubmit, loading, error }) {
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 w-full">
      {/* Email Field */}
      <div className="space-y-2">
        <label className="text-xs font-black text-slate-400 uppercase tracking-widest ml-1">Email Address</label>
        <div className="relative group">
          <div className={`absolute left-4 top-1/2 -translate-y-1/2 transition-colors duration-300 ${formData.email ? 'text-[#1B6CA8]' : 'text-slate-400 group-focus-within:text-[#1B6CA8]'}`}>
            <Mail size={18} />
          </div>
          <input
            type="email"
            name="email"
            placeholder="awesome@user.com"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full pl-12 pr-4 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-700 font-medium placeholder:text-slate-300 transition-all duration-300 focus:bg-white focus:border-[#1B6CA8] focus:ring-4 focus:ring-blue-50 outline-none"
          />
        </div>
      </div>

      {/* Password Field */}
      <div className="space-y-2">
        <div className="flex justify-between items-center ml-1">
          <label className="text-xs font-black text-slate-400 uppercase tracking-widest">Password</label>
        </div>
        <div className="relative group">
          <div className={`absolute left-4 top-1/2 -translate-y-1/2 transition-colors duration-300 ${formData.password ? 'text-[#1B6CA8]' : 'text-slate-400 group-focus-within:text-[#1B6CA8]'}`}>
            <Lock size={18} />
          </div>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="••••••••••••"
            value={formData.password}
            onChange={handleChange}
            required
            className="w-full pl-12 pr-12 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-700 font-medium placeholder:text-slate-300 transition-all duration-300 focus:bg-white focus:border-[#1B6CA8] focus:ring-4 focus:ring-blue-50 outline-none"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-[#1B6CA8] transition-colors duration-300 focus:outline-none"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="flex items-center gap-2 p-4 bg-red-50 border border-red-100 rounded-xl text-red-600 animate-fadeIn">
          <AlertCircle size={18} />
          <p className="text-sm font-bold">{error}</p>
        </div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        disabled={loading}
        className="w-full py-4 bg-[#3AA8A7] hover:bg-[#2d8d8c] text-white rounded-full font-black tracking-widest uppercase text-sm shadow-lg shadow-teal-100 transition-all duration-300 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] disabled:opacity-70 disabled:hover:scale-100 flex items-center justify-center gap-3 mt-8"
      >
        {loading ? (
          <>
            <Loader2 className="animate-spin" size={18} />
            <span>Verifying...</span>
          </>
        ) : (
          "Log In"
        )}
      </button>
    </form>
  );
}

export default LoginForm;
